import type { Portal, PortalKey } from './types';

/**
 * Definições COMPARTILHADAS dos portais TMR (fonte: handoff Claude Design).
 *
 * Cada app importa o seu portal daqui e pode sobrescrever campos na sua própria
 * camada isolada (apps/<app>/src/portal.ts), sem afetar os demais.
 */
export const portals: Record<PortalKey, Portal> = {
  paciente: {
    id: 'paciente',
    name: 'Portal do Paciente',
    short: 'Paciente',
    eyebrow: 'Acesso · Paciente',
    keyword: 'Cuidar.',
    tagline: ['A consulta hoje.', 'A conta, no seu tempo.'],
    sub: 'Sua carteira de saúde, sempre com você.',
    motion: 'breathe',
    accent: 'oklch(78% 0.105 158)', // sage green
    accentSoft: 'oklch(78% 0.105 158 / 0.18)',
    base: 'var(--forest-900)',
    baseDeep: 'var(--forest-950)',
    identifier: { label: 'E-mail', placeholder: 'voce@email.com', type: 'email', autocomplete: 'email', validation: 'email' },
    createLabel: 'Primeira vez aqui? Criar conta',
    secure: false,
    footnote: 'Ambiente seguro',
  },
  empresa: {
    id: 'empresa',
    name: 'Portal da Empresa',
    short: 'Empresa',
    eyebrow: 'Acesso · Empresa',
    keyword: 'Conectar.',
    tagline: ['Receba mais rápido.', 'Atenda mais pacientes.'],
    sub: 'Repasses, agenda e conciliação em tempo real.',
    motion: 'flows',
    accent: 'oklch(68% 0.135 168)', // bright emerald
    accentSoft: 'oklch(68% 0.135 168 / 0.16)',
    base: 'var(--forest-900)',
    baseDeep: 'var(--forest-950)',
    identifier: { label: 'CNPJ ou e-mail', placeholder: '00.000.000/0000-00', type: 'text', autocomplete: 'username', validation: 'cnpj-or-email' },
    createLabel: 'Cadastrar minha empresa',
    secure: false,
    footnote: 'Mais de 8.000 unidades conectadas',
  },
  cobranca: {
    id: 'cobranca',
    name: 'Portal de Cobrança',
    short: 'Cobrança',
    eyebrow: 'Acesso · Cobrança',
    keyword: 'Receber.',
    tagline: ['Cada cobrança no lugar.', 'Cada repasse no prazo.'],
    sub: 'Boletos, links e conciliação em um só painel.',
    motion: 'float',
    accent: 'oklch(80% 0.115 78)', // gold
    accentSoft: 'oklch(80% 0.115 78 / 0.16)',
    base: 'var(--forest-900)',
    baseDeep: 'var(--forest-950)',
    identifier: { label: 'E-mail corporativo', placeholder: 'nome@empresa.com', type: 'email', autocomplete: 'email', validation: 'email' },
    createLabel: null,
    secure: false,
    footnote: 'Conciliação em tempo real',
  },
  admin: {
    id: 'admin',
    name: 'Portal do Administrador',
    short: 'Admin',
    eyebrow: 'Acesso · Administrador',
    keyword: 'Operar.',
    tagline: ['Visão total.', 'Controle total.'],
    sub: 'O painel de operações da plataforma TMR.',
    motion: 'trellis',
    accent: 'oklch(72% 0.070 232)', // cool steel
    accentSoft: 'oklch(72% 0.070 232 / 0.16)',
    base: 'var(--forest-950)',
    baseDeep: 'oklch(14% 0.020 200)',
    identifier: { label: 'E-mail corporativo', placeholder: 'nome@tmr.com.br', type: 'email', autocomplete: 'email', validation: 'email' },
    createLabel: null,
    secure: true,
    footnote: 'Verificação em duas etapas',
  },
};

export const portalOrder: PortalKey[] = ['paciente', 'empresa', 'cobranca', 'admin'];
